import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const CorreggiDescrizioneDialog = ({ open, onOpenChange, voce, onSaved }) => {
  const [testo, setTesto] = useState(voce.descrizione);
  const [motivo, setMotivo] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/righe/${voce.id}/excel-descrizione`, { descrizione: testo, motivo });
      toast.success("Descrizione corretta. Il testo originale resta conservato.");
      onSaved(data);
      onOpenChange(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore nel salvataggio");
    } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="descrizione-dialog">
        <DialogHeader>
          <DialogTitle>Correggi descrizione di lavoro</DialogTitle>
          <DialogDescription>La modifica viene registrata con autore e data. Il testo originale importato e il file Excel archiviato non vengono modificati.</DialogDescription>
        </DialogHeader>
        <Textarea value={testo} onChange={(e) => setTesto(e.target.value)} rows={12} className="text-sm" data-testid="descrizione-textarea" />
        <div className="text-[11px] text-slate-500 text-right">{testo.length} caratteri</div>
        <Input value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Motivo (facoltativo), es. completamento testo troncato" data-testid="descrizione-motivo" />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="descrizione-annulla">Annulla</Button>
          <Button onClick={save} disabled={saving || !testo.trim() || testo.trim() === voce.descrizione} data-testid="descrizione-salva">{saving ? "Salvataggio…" : "Salva correzione"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
